// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__eiyaB","boxTitle":"Qualiphy_boxTitle__3OweV","box":"Qualiphy_box__3M56A","toggleWrap":"Qualiphy_toggleWrap__1DQdl"};